var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarpLogo = function SvgWarpLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006DA8",
    d: "M15.877 24.62H3.599A3.6 3.6 0 0 1 0 21.021V7.05a3.6 3.6 0 0 1 3.599-3.598h17.57z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9F73FF",
    d: "M15.97 0h12.278a3.6 3.6 0 0 1 3.599 3.599V17.57a3.6 3.6 0 0 1-3.599 3.6h-17.57z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#warp-logo_svg__a)",
    d: "M15.97 0h12.278a3.6 3.6 0 0 1 3.599 3.599V17.57a3.6 3.6 0 0 1-3.599 3.6h-17.57z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "warp-logo_svg__a",
    x1: 17.904,
    x2: 35.298,
    y1: 17.327,
    y2: 3.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#01FFC2"
  })))));
};
export default SvgWarpLogo;